import { useState, useEffect } from "react";
import "./LoadingProgress.css";

function LoadingProgress({ Page }) {
	const [loadingProgress, setLoadingProgress] = useState(0);

	useEffect(() => {
		const interval = setInterval(() => {
			setLoadingProgress((prev) => {
				if (prev >= 100) {
					clearInterval(interval);
					return 100;
				}
				return prev + 5;
			});
		}, 100);
		return () => clearInterval(interval);
	}, []);

	if (loadingProgress < 100) {
		return (
			<div className="loading-progress">
				<div className="progress-text">KulDim Game</div>
				<div className="progress-container">
					<div className="progress-bar" style={{ width: `${loadingProgress}%` }}></div>
				</div>
			</div>
		);
	}

	return <Page />;
}

export default LoadingProgress;
